import Vue from 'vue'
import Vuex from 'vuex'
import getters from './getters'







// 批量导入./module 下的所有模块
const path = require('path')
const file = require.context('./modules', false, /\.js$/)
const  modules = {}
file.keys().forEach(key => {
  const name = path.basename(key,'.js')
  modules[name] = file(key).default || file(key)
})

Vue.use(Vuex)

export default new Vuex.Store({
  modules:modules,
  getters:getters
})
